export default {"src":"/_next/static/media/icon_tell1.88aefece.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};